<template>
	<div>
		<div class="hidden-xs-only">
			<el-carousel height="722px" autoplay arrow="never" indicator-position="none">
				<el-carousel-item v-for="(item,index) in info.community_info.community_images" :key="index">
					<img :src="item" class="width-100 h-722" mode="widthFix" />
				</el-carousel-item>
				<div class="fu w-410 h-300 bgc c-white p-25 p-l-40 p-r-40">
					<div class="f-24 c-white">{{info.community_info.community_name}}</div>
					<div class="m-t-25 d-flex-row">
						<img src="../../assets/image/housing/1.png" class="w-14 h-14 m-r-5" />
						<span class="f-14 c-white">周边配套：公交/商业/教育/医疗</span>
					</div>
					<div class="m-t-25 d-flex-row">
						<img src="../../assets/image/housing/2.png" class="w-14 h-14 m-r-5" />
						<span class="f-14 c-white">公寓面积：{{info.community_info.total_area}}㎡</span>
					</div>
					<div class="m-t-25 d-flex-row">
						<img src="../../assets/image/housing/3.png" class="w-14 h-14 m-r-5" />
						<span class="f-14 c-white">公寓地址：{{info.community_info.address_infor}}</span>
					</div>
					<div class="d-flex-between m-t-40">
						<div class="f-20 c-FCE3C0">{{info.community_info.rooms_num}}套</div>
						<div @click="mapway"
							class="w-100 h-36 f-14 br-60 bgc-FCE3C0 c-965E1C d-flex-center d-flex-items-center">
							查看地图
						</div>
					</div>
				</div>
			</el-carousel>
			<div class="d-flex-center bgc-f4f4f4">
				<div class="w-80p p-t-60">
					<div class="f-20 c-00 font-weight-bold d-flex-center">门店介绍</div>
					<div class="m-t-50 f-14 c-33 lh-20">
						{{info.community_info.synopsis}}
						<!-- 博众新城地处长春市汽车厂区，北至红领巾路、南至支农大街、西至飞跃路、东至奔驰路。小区内共有住宅房屋9套，建筑面积为525.77平方米，其中住宅为二室一厅，户型方正、空间布局合理、干湿分离、利用率高、家具家电等基础设施完善，能够很好的满足人才生活需求；园区生活气氛浓厚，绿化分布合理，力致为每一位人才提供优质的生活空间。
						<br />
						<br />
						园区周边商业配套齐全，各类生活综合超市较多、医院及各类中西医诊所配备完善、教育机构品质优越、银行种类齐全，距一汽车百3公里、距欧亚卖场2.9公里、距一汽文化宫2.4公里、距一汽正门2.2公里、距吉大四院1.
						5公里、距新世纪超市1.2公里、距一汽十一小800米、距一汽六中500米、距岱山公园500米、飞跃路千米实景商业街就在园区门口；同时园区交通便捷，周边拥有多条公交路线：139路、156路、195路；保障了每一位人才的便捷出行。 -->
					</div>
					<div class="p-b-60 m-t-30">
						<div class="d-flex-between">
							<div class=" d-flex-row br-10 p-15 m-t-10 w-50p d-flex-items-center">
								<div class="w-32">
									<img src="../../assets/image/img/l-1.png" class="w-32" />
									<div class="f-15 c-33 m-t-10 d-flex-center">生活</div>
								</div>
								<div class="f-15 c-33 w-80p m-l-30 lh-20">{{info.community_info.lifes}}</div>
							</div>
							<div class=" d-flex-row br-10 p-15 m-t-10 w-50p d-flex-items-center">
								<div class="w-32">
									<img src="../../assets/image/img/l-2.png" class="w-32" />
									<div class="f-15 c-33 m-t-10 d-flex-center">医疗</div>
								</div>
								<div class="f-15 c-33 w-80p m-l-30 lh-20">{{info.community_info.medical_care}}</div>
							</div>
						</div>
						<div class="d-flex-between">
							<div class=" d-flex-row br-10 p-15 m-t-10 w-50p d-flex-items-center">
								<div class="w-32">
									<img src="../../assets/image/img/l-3.png" class="w-32" />
									<div class="f-15 c-33 m-t-10 d-flex-center">交通</div>
								</div>
								<div class="f-15 c-33 w-80p m-l-30 lh-20">{{info.community_info.traffics}}</div>
							</div>
							<div class=" d-flex-row br-10 p-15 m-t-10 w-50p d-flex-items-center">
								<div class="w-32">
									<img src="../../assets/image/img/l-4.png" class="w-32" />
									<div class="f-15 c-33 m-t-10 d-flex-center">教育</div>
								</div>
								<div class="f-15 c-33 w-80p m-l-30 lh-20">{{info.community_info.educations}}</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="d-flex-center bgc-white">
				<div class="w-80p p-t-60 p-b-70">
					<div class="f-20 c-00 font-weight-bold m-b-50 d-flex-center">公寓周边配套</div>
					<div class="d-flex-wrap">
						<div @mouseover="mouseover(index)" v-for="(item,index) in apartment" :key="index"
							class="w-187 h-116" :class="nav==index?'bgc-F6F6F6 b-b-EE6C60':''">
							<div class="d-flex-row d-flex-center m-t-25">
								<img :src="item.img" class="w-30 h-30" />
							</div>
							<div class="d-flex-center m-t-20 f-16 c-66">{{item.name}}</div>
						</div>
					</div>
				</div>
			</div>

			<div class="bgc-f4f4f4">
				<div class="f-20 c-00 font-weight-bold d-flex-center m-t-40 m-b-80">房型展示</div>
				<div class="d-flex-center gunscroll" style="overflow-x:scroll;overflow: hidden;">
					<div class="d-flex-row" style="overflow: auto;">
						<div @click="go(item.house_id)" v-for="(item,index) in info.hourse_list" :key="index"
							:class="index!=info.hourse_list.length? 'm-r-25':''" class="b-all-C9C6C6"
							style="width: 300px !important;">
							<img :src="item.image" class="w-300 h-220" />
							<div class="bgc-white p-t-10 p-l-25 p-r-25 w-300">
								<div class="f-20 c-33 font-weight-bold">{{item.hr_name}}</div>
								<div class="f-16 c-66 m-t-10">
									<span>{{item.house_categorylist}}</span>
									<span class="m-r-10 m-l-10">|</span>
									<span>{{item.measure_area}}</span>
								</div>
								<div class="f-20 c-EC4738 m-t-20 p-b-30">￥{{item.now_price}}/月</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div id="map" class="bgc-white m-t-80 p-t-50">
				<div class="f-20 c-00 font-weight-bold d-flex-center m-b-80">小区周边</div>
				<!-- 周边交通配套 -->
				<div class="bm-view" :key="clientWidth">
					<!-- <baidu-map class="bm-view" :center="center" :zoom="zoom" @ready="handler">
						<bm-marker :position="center" :dragging="true" animation="BMAP_ANIMATION_BOUNCE">
						</bm-marker>
						<bm-info-window :position="center" :show="infoWindow.show" @close="infoWindowClose"
							@open="infoWindowOpen">
							<p v-text="infoWindow.name" class="f-14 c-00 m-t-10"></p>
							<p v-text="infoWindow.text" class="f-12 c-99 m-t-10"></p>
						</bm-info-window>
					</baidu-map> -->
					<el-amap
					v-if="clientWidth>767"
              		    ref="map"
              		    :vid="'amapDemo'"
              		    :center="center"
              		    :zoom="zoom"
              		    class="bm-view"
						
              		   >
              		   <el-amap-marker :position="center">
              		   </el-amap-marker>
              		</el-amap>
					<!-- <div class="w-380 h-320 fu1">
						<div class="width-100 d-flex-row">
							<div v-for="(item,index) in tab" :key="index" @click="choice(index)"
								:class="tnav==index?'bgc-white':'bgc-E5EBF1'"
								class="d-flex-center d-flex-items-center w-25p f-14 c-33 h-33">
								{{item}}
							</div>
						</div>
						<div class="width-100 bgc-white over h-320">
							<div @click="select(index,item.center,item)" v-for="(item,index) in matching" :key="index"
								class="p-15">
								<div class="b-b d-flex-row p-b-25 d-flex-items-center">
									<img :src="mnav==index? require('@/assets/image/housing/r.png'):require('@/assets/image/housing/b.png')"
										class="w-15 h-15 m-r-15" />
									<div class="">
										<div class="f-12 c-00">{{item.name}}</div>
										<div class="f-12 c-99 m-t-5">{{item.text}}</div>
									</div>
								</div>
							</div>
						</div>
					</div> -->
				</div>
			</div>
		</div>

		<div class="hidden-sm-and-up">
			<el-carousel height="300px" autoplay arrow="never" indicator-position="none">
				<el-carousel-item v-for="(item,index) in info.community_info.community_images" :key="index">
					<img :src="item" class="width-100 h-300" mode="widthFix" />
				</el-carousel-item>
			</el-carousel>

			<div class="bgc-white p-30">
				<div class="f-20 c-00 font-weight-bold">{{info.community_info.community_name}}</div>
				<div class="m-t-20 d-flex-row d-flex-items-center">
					<img src="@/assets/image/housing/m-1.png" class="w-14 h-14 m-r-10" />
					<span>周边配套：公交/商业/教育/医疗</span>
				</div>
				<div class="m-t-20 d-flex-row d-flex-items-center">
					<img src="@/assets/image/housing/m-2.png" class="w-14 h-14 m-r-10" />
					<span>公寓面积：{{info.community_info.total_area}}㎡</span>
				</div>
				<div class="m-t-20 d-flex-row d-flex-items-center">
					<img src="@/assets/image/housing/m-3.png" class="w-14 h-14 m-r-10" />
					<span class="">公寓地址：{{info.community_info.address_infor}}</span>
					<!-- overtext -->
				</div>
				<div class="m-t-20 d-flex-items-center d-flex-between">
					<div class="f-24 c-00 font-weight-bold">{{info.community_info.rooms_num}}套</div>
					<div @click="gomap" class="bgc-FCE3C0 c-965E1C w-100 h-40 br-60 d-flex-items-center d-flex-center">
						查看地图
					</div>
				</div>
			</div>

			<div class="bgc-white b-t p-b-20">
				<div class="f-20 c-00 font-weight-bold m-t-20 m-l-20 m-r-20">门店介绍</div>
				<div class="f-14 c-00 m-t-30 lh-20 m-l-20 m-r-20 m-t-20" :class="!show? 'discharge':'harvest'">
					{{info.community_info.synopsis}}
					<!-- 	博众新城地处长春市汽车厂区，北至红领巾路、南至支农大街、西至飞跃路、东至奔驰路。小区内共有住宅房屋9套，建筑面积为525.77平方米，其中住宅为二室一厅，户型方正、空间布局合理、干湿分离、利用率高、家具家电等基础设施完善，能够很好的满足人才生活需求；园区生活气氛浓厚，绿化分布合理，力致为每一位人才提供优质的生活空间。
					<br>园区周边商业配套齐全，各类生活综合超市较多、医院及各类中西医诊所配备完善、教育机构品质优越、银行种类齐全，距一汽车百3公里、距欧亚卖场2.9公里、距一汽文化宫2.4公里、距一汽正门2.2公里、距吉大四院1.
					<br>5公里、距新世纪超市1.2公里、距一汽十一小800米、距一汽六中500米、距岱山公园500米、飞跃路千米实景商业街就在园区门口；同时园区交通便捷，周边拥有多条公交路线：139路、156路、195路；保障了每一位人才的便捷出行。 -->
				</div>
				<div @click="collect" class="b-t m-t-10 d-flex-center p-t-10">
					<i :class="show?'el-icon-arrow-up':'el-icon-arrow-down'" class="f-25 c-C6C8C9"></i>
				</div>
				<div class="bgc-f8f8f8 d-flex-row br-10 p-15 m-t-10 w-100p-30 d-flex-items-center m-l-15">
					<div class="">
						<img src="../../assets/image/img/l-1.png" class="w-22" />
						<div class="f-12 c-33">生活</div>
					</div>
					<div class="f-12 c-33 w-80p m-l-30 lh-20">{{info.community_info.lifes}}</div>
				</div>
				<div class="bgc-f8f8f8 d-flex-row br-10 p-15 m-t-10 w-100p-30 d-flex-items-center m-l-15">
					<div class="">
						<img src="../../assets/image/img/l-2.png" class="w-22" />
						<div class="f-12 c-33">医疗</div>
					</div>
					<div class="f-12 c-33 w-80p m-l-30 lh-20">{{info.community_info.medical_care}}</div>
				</div>
				<div class="bgc-f8f8f8 d-flex-row br-10 p-15 m-t-10 w-100p-30 d-flex-items-center m-l-15">
					<div class="">
						<img src="../../assets/image/img/l-3.png" class="w-22" />
						<div class="f-12 c-33">交通</div>
					</div>
					<div class="f-12 c-33 w-80p m-l-30 lh-20">{{info.community_info.traffics}}</div>
				</div>
				<div class="bgc-f8f8f8 d-flex-row br-10 p-15 m-t-10 w-100p-30 d-flex-items-center m-l-15">
					<div class="">
						<img src="../../assets/image/img/l-4.png" class="w-22" />
						<div class="f-12 c-33">教育</div>
					</div>
					<div class="f-12 c-33 w-80p m-l-30 lh-20">{{info.community_info.educations}}</div>
				</div>
			</div>

			<div class="bgc-white p-20 m-t-20 p-b-30">
				<div class="f-20 c-00 font-weight-bold">公寓配套</div>
				<div class="d-flex-wrap m-t-20">
					<div v-for="(item,index) in apartment" :key="index" class="w-110 h-90">
						<div class="d-flex-row d-flex-center">
							<img :src="item.img" class="w-30 h-30 m-t-15" />
						</div>
						<div class="d-flex-center m-t-20 f-16 c-66">{{item.name}}</div>
					</div>
				</div>
			</div>

			<div class="bgc-white p-20 m-t-20">
				<div class="f-20 c-00 font-weight-bold m-b-20">房型展示</div>
				<list-box @choose="go" :list="info.hourse_list"></list-box>
			</div>

			<div id="mapmap" class="bgc-white p-20 m-t-20">
				<div class="f-20 c-00 font-weight-bold m-b-20">小区周边</div>
				<div class="bm-view1" :key="clientWidth">
					<!-- <baidu-map class="bm-view1" :center="center" :zoom="zoom" @ready="handler">
						<bm-marker :position="center" :dragging="true" animation="BMAP_ANIMATION_BOUNCE">
						</bm-marker>
						<bm-info-window :position="center" :show="infoWindow.show" @close="infoWindowClose"
							@open="infoWindowOpen">
							<p v-text="infoWindow.name" class="f-14 c-00 m-t-10"></p>
							<p v-text="infoWindow.text" class="f-12 c-99 m-t-10"></p>
						</bm-info-window>
					</baidu-map> -->
					<el-amap
						v-if="clientWidth<767"
              		    ref="map"
              		    :vid="'amapDemo'"
              		    :center="center"
              		    :zoom="zoom"
						
              		    class="bm-view1"
              		   >
              		   <el-amap-marker :position="center">
              		   </el-amap-marker>
              		</el-amap>
					<!-- <div class="d-flex-center">
						<div class="w-300 fu2">
							<div class="width-100 d-flex-row">
								<div v-for="(item,index) in tab" :key="index" @click="choice(index)"
									:class="tnav==index?'bgc-white':'bgc-E5EBF1'"
									class="d-flex-center d-flex-items-center w-25p f-14 c-33 h-33">
									{{item}}
								</div>
							</div>
							<div class="width-100 bgc-white over h-140">
								<div @click="select(index,item.center,item)" v-for="(item,index) in matching"
									:key="index" class="p-10 b-b">
									<div class="d-flex-row d-flex-items-center">
										<img :src="mnav==index? require('@/assets/image/housing/r.png'):require('@/assets/image/housing/b.png')"
											class="w-15 h-15 m-r-15" />
										<div class="">
											<div class="f-12 c-00">{{item.name}}</div>
											<div class="f-12 c-99 m-t-5">{{item.text}}</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div> -->
				</div>
			</div>


		</div>
	</div>
</template>

<script>
	import listBox from '@/components/list.vue'
	import {
		Loading
	} from 'element-ui';
	import {
		list,
		apartment,
		room,
		matching,
		list1
	} from './config/index.js'
	export default {
		components: {
			listBox
		},
		data() {
			return {
				list: list,
				list1: list1,
				apartment: apartment,
				room: room,
				matching: matching,
				nav: -1,
				center: [ 116.404, 39.915 ],
				zoom: 13,
				tab: ['公交', '商业', '教育', '医疗'],
				tnav: 0,
				mnav: 0,
				infoWindow: {
					show: false,
					text: '',
					name: ''
				},
				show: false,
				target: '',
				info: {
					community_info: {},
					hourse_list: {}
				},
				clientWidth:document.documentElement.clientWidth
			}
		},
		mounted() {
			this.getinfo(this.$route.query.community_id)
			window.onresize = ()=> {
				this.clientWidth = document.documentElement.clientWidth
			};
		},
		methods: {
			async getinfo(community_id) {
				const loading = this.$loading({
					lock: true,
					text: '正在加载...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
				const res = await this.$service.post({
					url: '/api/web/v1/app_get_community_info',
					data: {
						community_id: community_id
					}
				})
				this.info = res.info;
				// this.center = res.info.community_info.address_info_location;
				this.center = [Number(res.info.community_info.lng),Number(res.info.community_info.lat)];
				console.log(this.center);
				this.$nextTick(() => {
					loading.close();
				}, 1000);

			},
			gomap() {
				document.querySelector("#mapmap").scrollIntoView();
			},
			mapway() {
				document.querySelector("#map").scrollIntoView();
			},
			collect() {
				this.show = !this.show;
			},
			go(e) {
				if (window.localStorage.getItem('token') == null) {
					this.$message.error('请先登录')
					return
				}
				this.$router.push({
					path: "/introduce",
					query: {
						house_id: e
					}
				});
			},
			infoWindowClose(e) {
				this.infoWindow.show = false
			},
			infoWindowOpen(e) {
				this.infoWindow.show = true
			},
			clear() {
				this.infoWindow.contents = ''
			},
			// select(index, center, item) {
			// 	this.mnav = index;
			// 	this.center = center;
			// 	this.infoWindow.show = true;
			// 	this.infoWindow.text = item.text;
			// 	this.infoWindow.name = item.name;
			// },
			choice(index) {
				this.tnav = index;
			},
			mouseover(index) {
				this.nav = index;
			},
			handler({
				BMap,
				map
			}) {
				console.log(BMap, map)
				this.center.lng = 116.404
				this.center.lat = 39.915
				this.zoom = 15
			}
		}
	}
</script>

<style lang="scss" scoped>
	.bm-view {
		width: 100vw;
		height: 420px;
	}

	.bm-view1 {
		width: 100%;
		height: 420px;
	}

	.fu {
		position: absolute;
		left: 70%;
		z-index: 2;
		bottom: 0;
	}

	.fu1 {
		position: relative;
		left: 70%;
		top: -380px;
	}

	.fu2 {
		position: relative;
		top: -180px;
	}

	.bgc {
		background: rgba(0, 0, 0, 0.66);
	}

	.c-FCE3C0 {
		color: #FCE3C0;
	}

	.bgc-FCE3C0 {
		background: #FCE3C0;
	}

	.c-965E1C {
		color: #965E1C;
	}


	.over {
		overflow-y: scroll;
	}

	/* // 滚动条本体，要想设置滚动条样式，需要先设置该元素 */
	::-webkit-scrollbar {
		height: 6px;
		width: 6px;
	}

	/* // 滚动条滑块 */
	::-webkit-scrollbar-thumb {
		background-color: #eee;
		border-radius: 3px;
	}

	.gunscroll ::-webkit-scrollbar {
		height: 10px;
		width: 6px;
		border-radius: 60px;
	}

	.gunscroll ::-webkit-scrollbar-thumb {
		background-color: #EE6C60;
		border-radius: 60px;
	}

	.discharge {
		height: 40px;
		overflow: hidden;
	}

	.bgc-f8f8f8 {
		background: #f8f8f8;
	}

	.w-100p-30 {
		width: calc(100% - 30px);
	}
</style>
